
import React from "react";
import KPISection from "../components/KPISection";
import ChartsSection from "../components/ChartsSection";
import { dashboardData } from "../data/dashboardData";
import 'bootstrap/dist/css/bootstrap.min.css';
function Dashboard() {
  return (
    <div>
      <h3 className="mb-4 gold-text">
        Enterprise Interior Analytics Dashboard
      </h3>

      <KPISection summary={dashboardData.summary} />

      <ChartsSection data={dashboardData} />
    </div>
  );
}

export default Dashboard;
